<template>
  <div class="zoom row"
       v-if="visible">
    <div class="zoom-container">
      <div class="zoom-thumb column left"
           v-if="!isHome">
        <transition enter-active-class='fade-enter-active'
                    enter-class="fade-enter">
          <div class="thumb"
               @mouseover="showThumbL=true"
               @mouseout="showThumbL=false"
               @click="prevPage"
               v-show="showThumbL">
            <transition enter-active-class='fade-enter-active'
                    enter-class="none">
            <img :src="srcList[this.currentPage-1].thumburl"
                 @load="thumbLoad"
                 v-show="thumbShow" />
            </transition>
            <label>{{this.currentPage}}</label>
          </div>
        </transition>
      </div>
      <div class="zoom-thumb column right"
           v-if="!isLast">
        <transition enter-active-class='fade-enter-active'
                    enter-class="slide-enter">
          <div class="thumb"
               @mouseover="showThumbR=true"
               @mouseout="showThumbR=false"
               @click="prevPage"
               v-show="showThumbR">
            <transition enter-active-class='fade-enter-active'
                    enter-class="none">
            <img :src="srcList[this.currentPage+1].thumburl"
                  @load="thumbLoad"
                 v-show="thumbShow"/>
            </transition>
            <label>{{this.currentPage}}</label>
          </div>
        </transition>
      </div>
      <div class="zoom-nav column left"
           v-show="!isHome">
        <span style="transform:rotate(180deg)"
              @click="prevPage"
              @mouseover="showThumbL=true"
              @mouseout="showThumbL=false">&#10148;</span>
      </div>
      <scroll-content class="zoom-wrapper"
                      ref="cont">
        <div class="cont"
             @click="close">
          <transition enter-active-class='fade-enter-active'
                      enter-class="none">
            <div class="three"
                 v-show="page[0].active">
              <img :src="page[0].imgUrl" />
            </div>
          </transition>
          <transition enter-active-class='fade-enter-active'
                      v-on:after-enter="afterEnter"
                      :enter-class="enterClass">
            <div class="one"
                 :style="{zIndex:this.index}"
                 v-show="page[1].active">
              <img :src="page[1].imgUrl"
                   @load="pageOut" />
              <link-item class="page-link"
               v-for="item in page[1].links"
               :data='item'
               :first="page[1].links.filter(item => item.linktype === 'video')"
               :key="item.id"></link-item>
            </div>
          </transition>
          <transition enter-active-class='fade-enter-active'
                      v-on:after-enter="afterEnter"
                      :enter-class="enterClass">
            <div class="two"
                 :style="{zIndex:this.toggleIndex()}"
                 v-show="page[2].active">
              <img :src="page[2].imgUrl"
                   @load="pageOut" />
              <link-item class="page-link"
               v-for="item in page[2].links"
               :data='item'
               :first="page[2].links.filter(item => item.linktype === 'video')"
               :key="item.id"></link-item>
            </div>
          </transition>
        </div>
      </scroll-content>
      <div class="zoom-nav column right"
           v-show="!isLast"
           @mouseover="showThumbR=true"
           @mouseout="showThumbR=false">
        <span @click="nextPage">&#10148;</span>
      </div>
    </div>
  </div>
</template>
<script>
import scrollContent from '@/components/scrollContent.vue';
import linkItem from '@/components/linkItem.vue';

export default {
  name: 'zoomView',
  props: {
    srcList: Array,
    zoom_visible: Boolean,
    zoomPage: Number,
  },
  data() {
    return {
      currentPage: 0,
      pageName: null,
      firstload: false,
      preview: false,
      index: 1,
      dir: 'right',
      showThumbL: false,
      showThumbR: false,
      thumbShow: false,
      page: [
        { active: false, imgUrl: '' },
        { active: false, imgUrl: '', links: [] },
        { active: false, imgUrl: '', links: [] },
      ],
      enterClass: 'fade-enter',
      thumbEnterClass: 'fade-enter',
    };
  },
  mounted() {
    console.log('large', this.srcList);
    // this.page[0].imgUrl = this.imgUrl;
  },
  computed: {
    totalPage() {
      return this.srcList.length;
    },
    imgUrl() {
      return this.srcList.length > 0
        ? this.srcList[this.currentPage].largeurl
        : '';
    },
    isHome() {
      return this.currentPage === 0;
    },
    isLast() {
      return this.currentPage === this.totalPage - 1;
    },
    visible() {
      return this.zoom_visible;
    },
  },
  watch: {
    zoom_visible(val) {
      this.$nextTick(() => {
        if (val) this.$refs.cont.getHeight();
      });
    },
    visible(val) {
      if (val) {
        console.log(this.currentPage);
        this.index = 0;
        this.page[0].active = false;
        this.page[1].active = false;
        this.page[2].active = false;
        this.page[2].imgUrl = '';
        this.page[2].links = [];
        this.firstload = true;
        this.currentPage = this.zoomPage;
        this.goPage(this.currentPage);
      }
    },
  },
  methods: {
    thumbLoad() {
      this.thumbShow = true;
    },
    toggleIndex() {
      if (this.index === 1) {
        return 2;
      }
      return 1;
    },
    nextPage() {
      if (this.currentPage < this.totalPage) {
        this.goPage(Number(this.currentPage) + 1);
        this.dir = 'right';
        this.thumbShow = false;
      }
    },
    prevPage() {
      if (this.currentPage > 0) {
        this.goPage(Number(this.currentPage) - 1);
        this.dir = 'left';
        this.thumbShow = false;
      }
    },
    goPage(n) {
      if (n < this.totalPage && n > -1) {
        this.currentPage = n;
        console.log('跳转到', n);
        if (this.firstload) {
          // 加载预览图
          this.page[0].imgUrl = this.srcList[n].smallurl;
          this.page[0].active = true;
          this.preview = true;
        }
        // 加载大图
        const id = this.toggleIndex();
        this.page[id].imgUrl = this.srcList[n].largeurl;
        this.page[id].links = this.srcList[n].links;
        const m = Math.ceil(Number(n) / 2, 0);
        const contentUrl = `/catalog/${this.$store.state.company_id}/${this.$store.state.code}/h5/large/${this.srcList[n].pageid}`;
        const refererUrl = '/';
        if (window._czc) {
          window._czc.push(['_trackPageview', contentUrl, refererUrl]);
        }
        if (window._hmt) {
          window._hmt.push(['_trackPageview', contentUrl]);
        }
        if (window.ga) {
          window.ga('set', 'page', contentUrl);
          window.ga('send', 'pageview');
        }
        this.$gtag.pageview(contentUrl);
        this.$store.commit('updateCurrentPage', { currentPage: m });
      }
    },
    pageOut() {
      const id = this.toggleIndex();
      if (!this.firstload) {
        this.enterClass = this.dir === 'right' ? 'slide-enter' : 'fade-enter';
      } else {
        this.enterClass = 'none';
      }
      console.log(this.enterClass);
      this.page[id].active = true;
    },
    afterEnter() {
      if (!this.firstload) {
        console.log('删除大图', this.index);
        this.page[this.index].active = false;
        this.page[this.index].imgUrl = '';
        this.page[this.index].links = [];
        this.index = this.toggleIndex();
      } else {
        this.page[0].active = false;
        this.page[0].imgUrl = '';
        this.firstload = false;
        this.index = this.toggleIndex();
      }
    },
    close() {
      // this.visible = false;
      // this.$emit('zoomVisibleEvent', 'zoom', false);
      this.$store.commit('updateView', {
        view: 'book',
      });
    },
  },
  components: {
    scrollContent,
    linkItem,
  },
};
</script>
<style lang="less" scoped>
.zoom {
  height: 100%;
  width: 100%;
  z-index: 1000;
  //padding-left: 100px;
  //padding-right: 100px;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  &-container {
    height: 100%;
    width: 1252px;
    overflow: hidden;
    position: relative;
  }
  &-wrapper {
    .cont {
      width: 1200px;
      height: 1589px;
    }
    width: 1200px;
    height: 100%;
    position: absolute;
    margin-left: 25px;
    .one {
      z-index: 1;
      width: 1200px;
      height: 1589px;
      position: absolute;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .two {
      z-index: 2;
      width: 1200px;
      height: 1589px;
      position: absolute;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .three {
      z-index: 0;
      width: 1200px;
      height: 1589px;
      position: absolute;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  &-thumb {
    width: 25px;
    height: 100%;
    background: #eae4e4;
    color: black;
    line-height: 100%;
    position: absolute;
    z-index: 99;
    span {
      cursor: pointer;
    }
    .thumb {
      width: 100px;
      height: 155px;
      background: #eae4e4;
      margin: -80px 25px;
      border: 1px solid #eae4e4;
      font-size: 10px;
      z-index: 101;
      cursor: pointer;
      label{
        line-height: 20px;
      }
    }
  }
  &-nav {
    width: 25px;
    height: 100%;
    background: black;
    color: white;
    line-height: 100%;
    position: absolute;
    z-index: 100;
    span {
      cursor: pointer;
    }
  }
  .left {
    border-left: 1px solid #4a5464;
    left: 0px;
    top: 0px;
  }
  .right {
    right: 0px;
    .thumb {
      margin: -80px -102px;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateX(-100%);
}
.slide-enter {
  transform: translateX(100%);
}
.none {
  opacity: 0;
}
</style>
